import { render } from "./CustomLoader.vue?vue&type=template&id=8d4d96da&scoped=true"
import script from "./CustomLoader.vue?vue&type=script&lang=js"
export * from "./CustomLoader.vue?vue&type=script&lang=js"

import "./CustomLoader.vue?vue&type=style&index=0&id=8d4d96da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d4d96da"]])

export default __exports__